export const SUBSCRIPTION_LOADING = 'SUBSCRIPTION_LOADING' as const;
export const SUBSCRIPTION_LOADED = 'SUBSCRIPTION_LOADED' as const;
export const SUBSCRIPTION_LOADING_FAILED = 'SUBSCRIPTION_LOADING_FAILED' as const;
export const SUBSCRIPTION_PAYMENT_PROCESSING = 'SUBSCRIPTION_PAYMENT_PROCESSING' as const;
export const SUBSCRIPTION_PAYMENT_COMPLETE = 'SUBSCRIPTION_PAYMENT_COMPLETE' as const;
export const SUBSCRIPTION_PAYMENT_FAILED = 'SUBSCRIPTION_PAYMENT_FAILED' as const;
export const SUBSCRIPTION_RESET_MESSAGE = 'SUBSCRIPTION_RESET_MESSAGE' as const;
